import type { GridColDef } from '@mui/x-data-grid';
import type { PlanOverview } from '@vy/api-definition';
import { getBillingIntervalLabel } from '../../../../../contract/contract-page-components/ContractSummaryDetails/contract-summary-details-utils/get-billing-interval-label';
import { PlanStatusChip } from '../../../../../../components/design/PlanStatusChip';
import { getPlanDurationLabel } from '../../../../utils';

export const SELECT_PLAN_TEMPLATE_COLUMNS: GridColDef<PlanOverview>[] = [
  {
    field: 'status',
    headerName: 'Status',
    minWidth: 120,
    renderCell: ({ row }) => <PlanStatusChip status={row.status} />,
  },
  {
    field: 'name',
    headerName: 'Name',
    flex: 1,
    headerAlign: 'left',
    align: 'left',
    renderCell: ({ row }) => <span className="font-sans text-black">{row.name}</span>,
  },
  {
    field: 'billingInterval',
    headerName: 'Billing Interval',
    flex: 1,
    headerAlign: 'left',
    align: 'left',
    sortable: false,
    renderCell: ({ row }) => (
      <span className="font-sans text-black">{getBillingIntervalLabel(row.billingInterval)}</span>
    ),
  },
  {
    field: 'planDuration',
    headerName: 'Duration',
    flex: 1,
    headerAlign: 'center',
    align: 'center',
    sortable: false,
    renderCell: ({ row }) => (
      <span className="font-sans text-black">{getPlanDurationLabel(row.planDuration)}</span>
    ),
  },
  {
    field: 'customersCount',
    headerName: 'Customers',
    flex: 1,
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
];
